import { SCROLL_ALIGN, SCROLL_BEHAVIOR } from './constants';
import type { GridVirtualizersT, ScrollAlignT, ScrollBehaviorT, VirtualGridOverlayApiT } from './types';
export function createOverlayControls({
  columnVirtualizer,
  rowVirtualizer
}: GridVirtualizersT): VirtualGridOverlayApiT {
  return {
    scrollToColumn: (index: number, align: ScrollAlignT = SCROLL_ALIGN.auto, behavior: ScrollBehaviorT = SCROLL_BEHAVIOR.auto) => columnVirtualizer.scrollToIndex(index, {
      align,
      behavior
    }),
    scrollToRow: (index: number, align: ScrollAlignT = SCROLL_ALIGN.auto, behavior: ScrollBehaviorT = SCROLL_BEHAVIOR.auto) => rowVirtualizer.scrollToIndex(index, {
      align,
      behavior
    }),
    columnIndexAt: (clientX: number) => {
      const scrollElement = columnVirtualizer.scrollElement;
      if (!scrollElement) return null;
      const contentX = (columnVirtualizer.scrollOffset ?? 0) + (clientX - scrollElement.getBoundingClientRect().left);
      return columnVirtualizer.getVirtualItemForOffset(contentX).index;
    }
  };
}